import { render } from "./EditPopupPage.vue?vue&type=template&id=498442da&scoped=true"
import script from "./EditPopupPage.vue?vue&type=script&lang=js"
export * from "./EditPopupPage.vue?vue&type=script&lang=js"

import "./EditPopupPage.vue?vue&type=style&index=0&id=498442da&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498442da"]])

export default __exports__